import { render } from "./CompanyName.vue?vue&type=template&id=276c9f39&scoped=true&ts=true&lang=pug"
import script from "./CompanyName.vue?vue&type=script&lang=ts"
export * from "./CompanyName.vue?vue&type=script&lang=ts"

import "./CompanyName.vue?vue&type=style&index=0&id=276c9f39&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276c9f39"]])

export default __exports__